<template>
  <router-view
    id="main"
    :class="$style.main"
  />
</template>
<script setup>
import { useRouter } from 'vue-router'
import { scrollToTop } from '@/helpers/useMixin'
// import { onMounted } from '@vue/runtime-core'

const { beforeEach } = useRouter()

beforeEach((to, from) => {
  scrollToTop()
})

// let observer = null
// const intersectionObserverCallback = function (entries) {
//   entries.forEach((entry) => {
//     if (entry.isIntersecting) {
//       entry.target.classList.add('active')
//       observer.unobserve(entry.target)
//     }
//   })
// }

// onMounted(() => {
//   observer = new IntersectionObserver(intersectionObserverCallback, { threshold: 0.6 })
//   const targets = document.querySelectorAll('.js-show-on-scroll')
//   targets.forEach(function (target) {
//     target.classList.add('toFadeIn')
//     observer.observe(target)
//   })
// })
</script>
<style lang="scss" module>
.main {
  overflow: auto;
  height: 100vh;
}

:global(.toFadeIn) {
  opacity: 0;
  transition: all 0.5s;
  transform: translateY(20px);

  &.active {
    opacity: 1;
    transform: none;
  }
}
</style>
